import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { FormContext } from "../context/FormProvider";
import "../styles/form-container.css";
import "./styles/additionalinformation.css";

// Slide 10: Additional Information
const AdditionalInformation = ({
  setSlideStatus,
  slideState,
  formStateLoaded,
}) => {
  const [disabledInputs, setDisabledInputs] = useState([]);
  const { slide12, setSlide12 } = useContext(FormContext);

  const { user } = useContext(DashboardContext);

  useEffect(() => {
    if (user.id !== "argus_admin" && slide12.submitterName !== user.name) {
      setSlide12({
        ...slide12,
        submitterName: user.name,
        submitterEmail: user.email,
        submitterPhone: user.phone,
        submitterTitle:
          slide12.submitterTitle === "" && user.title !== ""
            ? user.title
            : slide12.submitterTitle,
      });
    }
  }, []);

  return (
    <>
      {formStateLoaded ? (
        <>
          <p className="important-text">
            Are you ready to submit this request? Please ensure all the slides
            are colored green inside the navigation window on the left.
            Submitting the request will make this form read-only and you will
            not be able to make any changes. An Argus team member will review
            your request and may suggest changes or ask for additional
            information.
          </p>
        </>
      ) : (
        <p className="slide-loading">Loading...</p>
      )}
    </>
  );
};

export default AdditionalInformation;
